// noinspection JSAnnotator
const state = {
  events: [],
  event: [],
  eventId: 0
};

// noinspection JSAnnotator
const mutations = {
  'SET_EVENT'(state, detail) {
    state.event = [];
    state.eventId = 0;
    if (detail) {
      state.event = detail;
      state.eventId = detail.eventId;
    }
  },
  'GET_EVENT'() {
    return state.event;
  },
  'UPDATE_EVENT'(state, detail) {
    state.event.unshift(detail);
  },
  'REMOVE_EVENT'() {
    state.event = [];
  },

  'SET_EVENTS'(state, detail) {
    state.events = [];
    if (detail) {
      if (detail.length > 0) {
        state.events = detail;
      }
    }
  },
  'GET_EVENTS'() {
    return state.events;
  },
  'UPDATE_EVENTS'(state, detail) {
    state.events.unshift(detail);
  },
  'REMOVE_EVENTS'() {
    state.events = [];
  },
};

const actions = {
  getEvent: ({commit}, detail) => {
    commit('GET_EVENT', detail);
  },
  setEvent: ({commit}, detail) => {
    commit('SET_EVENT', detail);
  },
  updateEvent: ({commit}, detail) => {
    commit('UPDATE_EVENT', detail);
  },
  removeEvent: ({commit}, detail) => {
    commit('REMOVE_EVENT', detail);
  },

  getEventList: ({commit}, detail) => {
    commit('GET_EVENTS', detail);
  },
  setEventList: ({commit}, detail) => {
    commit('SET_EVENTS', detail);
  },
  updateEventList: ({commit}, detail) => {
    commit('UPDATE_EVENTS', detail);
  },
  removeEventList: ({commit}, detail) => {
    commit('REMOVE_EVENTS', detail);
  }
};

const getters = {
  getEventList: () => {
    return state.events;
  },
  getEvent: (state) => {
    return state.event;
  },
  getEventId: (state) => {
    return state.eventId;
  },
};

export default {
  state,
  mutations,
  actions,
  getters
};




// WEBPACK FOOTER //
// ./src/store/modules/Event.store.js